import NavigationBar from "../../../components/NotificationBar/NotificationBar";

const Notification = () => {
  return (
    <>
      <div className="margin-bottom">
        <NavigationBar alert="User Registration" AlertInfo="8 March, 2024 | 12:32PM" SchName="Great Academy" Location="Lagos, Nigeria" AdminName="Eugene Adavore"
          mail="eugeneadavore@gmail.com"
          Contact="+234 695 4924 1421"
        />
      </div>
      <div className="margin-bottom">
        <NavigationBar alert="User Registration" AlertInfo="8 March, 2024 | 12:32PM" SchName="Great Academy" Location="Lagos, Nigeria" AdminName="Eugene Adavore"
          mail="eugeneadavore@gmail.com"
          Contact="+234 695 4924 1421"
        />
      </div>
      <div className="margin-bottom">
        <NavigationBar alert="User Registration" AlertInfo="8 March, 2024 | 12:32PM" SchName="Great Academy" Location="Lagos, Nigeria" AdminName="Eugene Adavore"
          mail="eugeneadavore@gmail.com"
          Contact="+234 695 4924 1421"
        />
      </div>
      <div className="margin-bottom">
        <NavigationBar alert="User Registration" AlertInfo="8 March, 2024 | 12:32PM" SchName="Great Academy" Location="Lagos, Nigeria" AdminName="Eugene Adavore"
          mail="eugeneadavore@gmail.com"
          Contact="+234 695 4924 1421"
        />
      </div>
    </>
  );
};

export default Notification;
